<template>
  <div class="clock">
    <div class="img-container">
      <img src="../../assets/NewYear/Cadenas.png" alt />
      <div class="code-container">
        <div class="flex">
          <select-number @update="one = $event" :content="one" />
          <select-number @update="two = $event" :content="two" />
          <select-number @update="three = $event" :content="three" />
          <select-number @update="four = $event" :content="four" />
        </div>
      </div>
    </div>
    <div class="hints">
      <div v-for="(hint, index) in reduceList" :key="index">
        <button
          :class="getClass(hint, index)"
          @click="display(hint.id)"
          :disabled="getClass(hint, index) === 'inactive' "
        >💡 #{{index + 1}}</button>
      </div>
    </div>
    <div v-for="(hint, index) in reduceList" :key="index">
      <hint
        v-if="hint.display"
        :content="hint.content"
        :index="index"
        :read="hint.read"
        warning="ATTENTION, il s'agit de la fin de l'aventure, ne découvrez pas cette partie si vous n'êtes pas encore entré dans le château du comte ! Poursuivre ?"
        @close="closeHints()"
        @continue="increment(hint.id)"
      />
    </div>
  </div>
</template>

<script>
import Hint from "../shared/Hint";
import SelectNumber from "../shared/SelectNumber";

export default {
  props: {
    hintList: Array
  },
  components: { SelectNumber, Hint },
  data() {
    return {
      one: "0",
      two: "0",
      three: "0",
      four: "0",
      success: false,
      hints: this.hintList,
      reduceList: this.hintList.filter(h => h.vue === "clock")
    };
  },
  watch: {
    one() {
      if (this.one === "1" && this.two === "9" && this.three === "5" && this.four === "3") {
        this.success = true;
      }
    },
    two() {
      if (this.one === "1" && this.two === "9" && this.three === "5" && this.four === "3") {
        this.success = true;
      }
    },
    three() {
      if (this.one === "1" && this.two === "9" && this.three === "5" && this.four === "3") {
        this.success = true;
      }
    },
    four() {
      if (this.one === "1" && this.two === "9" && this.three === "5" && this.four === "3") {
        this.success = true;
      }
    },
    success() {
      console.log("you win");
      this.$emit("update", true);
    }
  },
  methods: {
    closeHints() {
      this.hints.forEach(h => {
        h.display = false;
      });
    },
    display(id) {
      this.closeHints();
      this.hints.find(h => h.id === id).display = true;
    },
    getClass(hint, index) {
      if (this.hints.find(h => h.id === hint.id).read) return "read";
      if (index === 0) return "active";
      if (this.reduceList[index - 1].read) return "active";
      return "inactive";
    },
    increment(id) {
      this.hints.find(h => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
.clock {
  top: 0;
  position: relative;
  margin: 0;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.clock img {
  width: 60%;
}
.flex {
  display: flex;
  justify-content: space-between;
  background: grey;
  width: 18%;
  position: absolute;
  left: 39.4%;
  top: 56%;
  padding: 1%;
  border-radius: 5%;
}
.hints {
  position: absolute;
  bottom: 18%;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.hints button {
  font-family: "IBM Plex Mono", monospace;
  font-weight: bold;
  border: none;
  border-radius: 3px;
}
.hints button:focus {
  outline: none;
}
.inactive {
  cursor: not-allowed;
  background: #ce322c;
  color: rgb(235, 235, 235);
}
.active {
  cursor: pointer;
  background: #faa806;
  color: rgb(235, 235, 235);
}
.read {
  cursor: pointer;
  background: #01593b;
  color: rgb(235, 235, 235);
}
</style>
